import Circle from "../../components/Animations/Cricle";
import Square from "../../components/Animations/Square";
import Rhombus from "../../components/Animations/Rhombus";
import UncerTainIcons from "../../components/Animations/UncerTainIcon";
import TwoCircles from "../../components/Animations/TwoCircles";

export const ArrScrollService = [
  {
    animation: Circle,
    name: `Circle`,
    services: {
      width: "94px",
      height: "94px",
    },
    title: `WEBSITE DEVELOPMENT`,
    des: `We adopt fully Agile/Scrum methodology for our web design and development process. This allows us to quickly adapt to change of requirement and promptly deliver business value to website users. During the website design and development process, client always stays updated with the actual progress and collaborate with the team to respond to the feedbacks from end users.`,
    list: [],
  },

  {
    animation: Square,
    name: `Square`,
    services: {
      width: "94px",
      height: "94px",
    },
    title: `UX/UI DESIGN`,
    des: ` Great user experience design not only highlights and promotes your product, but it also has become a key part of building and growing customer confidence`,
    list: [],
  },

  {
    animation: Rhombus,
    name: `Rhombus`,
    services: {
      width: "94px",
      height: "94px",
    },
    title: ` QUALITY ASSURANCE`,
    des: `The quality assurance process starts at very early stage where we conduct inspection throughout the plan, written requirement document, software design document, etc. and go through to deployment phase when the website is deployed on live environment.`,
    list: [
    ],
  },

  {
    animation: UncerTainIcons,
    name: `UncerTainIcons`,
    services: {
      width: "94px",
      height: "94px",
    },
    title: `MAINTENANCE AND SUPPORT`,
    des: `We provide one year free-of-charge support for handling any programming problem from the live environment system. Our client will also benefit from the prompt response and support of the team with the plan of 24 hours feedback.\n\n\nWith a small subscription to system operation service, client can free hands from daily activities such as system monitoring, backup and restore, failure recovering, etc. It defines our end-to-end web design and development service.`,
  },
];

export const ArrIndustryExpertise = [
  {
    id: `0`,
    icon: `Bank`,
    title: `Banking & Finance`,
    des: `Stock market trading platform; Hyperledger smart-contract application for retail banking.`,
  },
  {
    id: `1`,
    icon: `Hearth`,
    title: `Health Care`,
    des: `SaaS for drug trails; Remote doctors and medication; Electronic Medical Records system.`,
  },
  {
    id: `2`,
    icon: `Education`,
    title: `Education`,
    des: `Online learning system; University ERP; Education Games for Kids; Mental Buzzles & Education`,
  },
  {
    id: `3`,
    icon: `Logistic`,
    title: `Logistic`,
    des: `Logistic management system; Warehouse management system`,
  },
  {
    id: `4`,
    icon: `Retailer`,
    title: `Retailer, B2B, B2C`,
    des: `Market-place solution; Omni-Channel management system; Integration of e-commerce, WMS and CRM.`,
  },
  {
    id: `5`,
    icon: `RealEstate`,
    title: `Real Estate`,
    des: `Real estate management system; Interior design market-place; Sub-contractor management system.`,
  },
  {
    id: `6`,
    icon: `Travel`,
    title: `Leisure & Travel`,
    des: `Travel portal; Tour booking; Social networks; Dating systems; Games; Music stores, Movie streamer.`,
  },
  {
    id: `7`,
    icon: `Utilities`,
    title: `Utilities`,
    des: `Expenses management system; Custom sportware measurement & tailoring; Health params wareable devices.`,
  },
];

export const ArrBlServices = {
  left: [
    {
      title: `BLOCKCHAIN CONSULTING SERVICES`,
      des: `Offering comprehensive consulting in various distributed ledger, smart contract, mainnet technologies and commitment to turn our client's existing distributed, decentralized applications into reality.`,
    },
    {
      title: `PRIVATE BLOCKCHAIN DEVELOPMENT`,
      des: `Build private blockchain application for enterprise and business with right permissions and rules. With strong knowledge and experience in Hyperledger, we develop blockchain system in several domains: Financial, Health Care, Retail, Manufacturing, Logistic.`,
    },
    {
      title: `CRYPTOCURRENCY DEVELOPMENT`,
      des: `We offer end to end Cryptocurrency Development Services using blockchain technology to help the client in building a unique digital coin for transactions, investment, token sales and much more.`,
    },
  ],
  right: [
    {
      title: `ENTERPRISE BLOCKCHAIN DEVELOPMENT`,
      des: ` Our blockchain experts will help you bring a high level of security and mobility to your enterprise by integrating the latest distributed ledger technologies, identity solutions, and smart contracts.`,
    },
    {
      title: `DAPP DEVELOPMENT`,
      des: `Our talented team of programmers provide highly secured Decentralised application.`,
    },
    {
      title: `SMART CONTRACT DEVELOPMENT`,
      des: `Automating business contracts by self building them from design, development, audit and optimization meeting business requirements.`,
    },
  ],
};

export const ArrOurCompetencies = [
  {
    id: `0`,
    icon: `Vali`,
    title: `STRONG EXPERIENCE`,
    des: `Start researching from 2016, our team were early activists in the blockchain community and still remain actively involved in its continued evolution. Thus, we are well positioned to support any blockchain initiative you are looking for.`,
  },
  {
    id: `1`,
    icon: `Com`,
    title: `IN-DEPTH DOMAIN EXPERTISE`,
    des: `We know how to apply blockchain technology to unlock benefits for the client in several domains: banking, finance, healthcare, ecommerce, etc`,
  },
  {
    id: `2`,
    icon: `Delivery`,
    title: `DELIVERY ABILITY`,
    des: `Proven experience & track record delivering successful Blockchain projects on time and within budget`,
  },
  {
    id: `3`,
    icon: `Agile`,
    title: `AGILE METHODOLOGIES`,
    des: `With all projects supervised by certified scrum masters, we ensure the readiness of your project to quickly embrace change entailed by new market demands.`,
  },
  {
    id: `4`,
    icon: `SecurityV3`,
    title: `SECURITY CONFIRMATION`,
    des: `We always pay the utmost attention to Intellectual Property (IP) protection, data security which has become indispensable to our long-term development strategy by applying ISO 27000 Series, GDPR compliance, CMMi level 3 Standard`,
  },
  {
    id: `5`,
    icon: `Strong`,
    title: `STRONG R&D ACTIVITY`,
    des: `Strong R&D activity to explore new technologies, optimal implementation options for next-gen projects`,
  },
];

export const ArrBlockchainTech = [
  {
    id: `0`,
    icon: `EthV1`,
    title: `Ethereum`,
    des: `Ethereum is a decentralized system that runs smart contracts as it now is one of the most popular blockchain app platforms. With strong experience and knowledge about Ethereum, our team is ready to listen your idea and consult to make it come true.`,
  },
  {
    id: `1`,
    icon: `Hyper`,
    title: `Hyperledger`,
    des: `Hyperledger is a multi-project open source collaborative effort hosted by The Linux Foundation, created to advance cross-industry blockchain technologies. We have worked on hybrid(off-chain and on-chain) projects with Hyperledger Fabric or Sawtooth framework to support client in several domains: Banking and Finance, Retail, Logistic, etc.`,
  },
];
